import { getFlowType } from '../utils/url-utils'
import { INSTRUMENTATION_TYPES } from '../constants'

export function getAnalyticsMeta(type, payload) {
  return { analytics: { type, payload } }
}

export function fromChoiceToReview(analyticsData) {
  const urlPathName = window.location.pathname || ''
  const unified = urlPathName.includes('homepage')
  const unifiedString = unified ? 'unified:' : ''

  const linkName = 'next'
  const flowType = getFlowType()
  const pageGroup = `main:p2p:${unifiedString}choice:fioption`
  const pageName = `main:p2p:${unifiedString}choice:fioption::node`
  const nextPageGroup = `main:p2p:${unifiedString}${flowType}::review`
  const nextPageName = `main:p2p:${unifiedString}${flowType}::review:node::`

  return getAnalyticsMeta(INSTRUMENTATION_TYPES.ACTION_WITH_DATA, {
    linkName,
    pageGroup: pageGroup,
    pageName: pageName,
    data: analyticsData,
    nextPageGroup: nextPageGroup,
    nextPageName: nextPageName,
    trackType: 'link',
  })
}

export function trackEditContacts({
  type = INSTRUMENTATION_TYPES.PAGE_CHANGE,
  linkName = '',
  pageName = '',
  pageGroup = '',
}) {
  return {
    type: '',
    meta: getAnalyticsMeta(type, {
      linkName,
      pageName,
      pageGroup,
    }),
  }
}
